import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import commonEn from './translations/en/common.json';
import commonFr from './translations/fr/common.json';

i18next
  .use(detector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    resources: {
      fr: {
        translation: commonFr,
      },
      en: {
        translation: commonEn,
      },
    },
  });

export default i18next;
